import './LeafletWMSLegend.css';

/**
* Cria um controle Leaflet com todas as layers WMS contidas em map
* Os params especificam parâmetros adicionais a serem incluidos na chamada GetLegendGraphic, como por exemplo cql_filter, env, etc.
* Em params, se especifica a layer e um objeto conténdo os parâmetros adicionais
* Um exemplo de chamada :
      map.addControl(getWMSLegend(map, {
        rodovia: {
          cql_filter: '1 > 1'
        }
      }));
* aonde se especifica que a layer chamada rodovia possui um cql_filter como parâmetro      
* Em reject_layers se especifica um array conténdo nomes de layers que não deverão aparecer legendas
*/

export const getWMSLegend = (map, params = {}, reject_layers = []) => {

    let legend = L.control({ position: 'bottomright' });
    
    legend.onAdd = function (map) {
        let div = L.DomUtil.create('div', 'info legend');
        const array_layers = getArrayLayers(map, reject_layers);
        array_layers.map( layer => {
            let layerName = layer.wmsParams.layers;
            let layer_params = params[layerName] ? params[layerName] : {};
            const url_legend = getLegendGraphic(layer, layer_params);
            div.innerHTML += '<img src="' + url_legend + '" alt="' + layerName + '"><br>';
            return layer;
        });
        return div; 
    };

    return legend;

}

const getArrayLayers = (map, reject_layers = []) => {
    let arr = [];
    map.eachLayer((layer) => {
        if (layer instanceof L.TileLayer && layer.wmsParams && !reject_layers.includes(layer.wmsParams.layers)) {
            arr.push(layer);
        }
        return layer;
    });
    return arr;
}

function getLegendGraphic(layer, params = {}) {

    const defaultParams = {
		request: 'GetLegendGraphic',
		version: '1.1.0',
		format: 'image/png',
		width: 20,
		height: 20,
        layer: layer.wmsParams.layers,
        legend_options: 'forceLabels:on;'
	};

    params = L.Util.extend(defaultParams, params || {});

    return layer._url + L.Util.getParamString(params, layer._url, true);

}



// WEBPACK FOOTER //
// ./src/LeafletWMSLegend.js